import { useSetSelectedPerson } from "@/shared/client";
import { useEffect, useState } from "react";
import { type CountPersonProps } from "./useCountPersonProps";

export const useCountPerson = ({ min, max, adult, child, infant, ...rest }: CountPersonProps) => {
    const { initialOnPrice, initialOffPrice, setNewOnPrice, setNewOffPrice } = rest;

    const [adultState, setAdultState] = useState(Number(min));
    const [adultUseState, setAdultUseState] = useState(0);
    const [childState, setChildState] = useState(0);
    const [infantState, setInfantState] = useState(0);
    const [totalAddFee, setTotalAddFee] = useState(0);
    const setSelectedPerson = useSetSelectedPerson();

    const totalCount = adultState + childState + infantState;
    const personCountMap: Record<0 | 1 | 2, number> = {
        0: adultState,
        1: childState,
        2: infantState,
    };

    const handleCountPerson = (e: React.MouseEvent<HTMLButtonElement>, idx: number, currentCount: number) => {
        const { currentTarget } = e;
        const isIncrement = currentTarget?.textContent === "+";
        if (!isIncrement && currentCount === 0) return;
        if (isIncrement && totalCount >= max) return;

        if (idx === 0) {
            if (isIncrement && adultState >= min) {
                setAdultState((prev) => prev + 1);
                setAdultUseState((prev) => prev + 1);
            }

            if (!isIncrement && adultState > min) {
                setAdultState((prev) => prev - 1);
                setAdultUseState((prev) => prev - 1);
            }
        }
        if (idx === 1) setChildState((prev) => (isIncrement ? prev + 1 : prev - 1));
        if (idx === 2) setInfantState((prev) => (isIncrement ? prev + 1 : prev - 1));
    };

    useEffect(() => {
        const adultFee = adultUseState * adult;
        const childFee = childState * child;
        const infantFee = infantState * infant;

        setTotalAddFee(adultFee + childFee + infantFee);

        const person = {
            adult: adultUseState,
            child: childState,
            infant: infantState,
        };
        setSelectedPerson(person);
    }, [adultState, adultUseState, childState, infantState]);

    setNewOnPrice(initialOnPrice + totalAddFee);
    setNewOffPrice(initialOffPrice + totalAddFee);

    return { handleCountPerson, personCountMap, totalCount };
};
